import { LitElement, html, styles, ifDefined, defineElement  } from '@mds/core';
import { dropdownCSS } from './dropdown.styles.js';

/**
 * Dropdown Web Component
 * @slot - This element has a slot
 */
export class MdsDropdown extends LitElement {
	static get styles() {
		return [...styles, dropdownCSS];
	}

	static get properties() {
		return {
			type: { attribute: 'data-type', type: String, reflect: true },
			title: { attribute: 'data-title', type: String, reflect: true },
			style: { type: String, reflect: true },
			top: { attribute: 'data-position-top', type: Number, reflect: true },
			left: { attribute: 'data-position-left', type: Number, reflect: true },
			hidden: { attribute: 'data-hidden', type: Boolean, reflect: true },
			break: { attribute: 'data-break', type: Boolean, reflect: true },
			tabindex: { type: String, reflect: true },
			topLevel: { attribute: 'data-toplevel', type: Boolean, reflect: true },
			ondark: { type: Boolean, reflect: true },
		};
	}

	constructor() {
		super();
		this.type = undefined;
		this.top = 0;
		this.left = 0;
		this.width = undefined;
		this.style = undefined;
		this.hidden = undefined;
		this.dropdown = undefined;
		this.toggle = undefined;
		this.title = undefined;
		this.break = false;
		this.topLevel = false;
		this.observer = new MutationObserver(this.__setPosition.bind(this));
	}

	firstUpdated(changedProperties) {
		this.__setToggle();
	}
	render() {
		return this.__dropdownTemplate();
	}


	__setToggle() {
		const toggletag = this.type === 'menu'
			? 'mds-navigation-link'
			: 'a'
		this.dropdown = this.shadowRoot.querySelector('.mds-dropdown');
		this.toggle = this.shadowRoot.host.closest(toggletag);
		this.toggle && this.observer.observe(this.toggle, { attributes: true });
		this.__setPosition();
	}
	__setPosition() {
		if(this.toggle){
			this.hidden = !this.toggle.hasAttribute('toggled');
			this.break = this.toggle.hasAttribute('break');
			this.topLevel = this.toggle.hasAttribute('icon');
			if(!this.break){
				this.top = this.toggle.offsetTop + this.toggle.clientHeight + 8;
				this.left = this.toggle.offsetLeft - ((this.dropdown.clientWidth - this.toggle.clientWidth)/2);
			}
		} else {
			this.hidden = true
		}
	}

	__dropdownTemplate() {
		this.__setPosition();
		this.style = `--pos-top:${+this.top}px; --pos-left:${+this.left}px;`;
		return html`
			<div class="mds-dropdown" style="${ifDefined(this.style)}" role='menu' ?hidden='${this.hidden}' >
				${this.title ? html`<h5 class='mds-dropdown-title'>${this.title}</h5>` : html``}
				<slot name="content"></slot>
			</div>
		`;
	}
}

defineElement('mds-dropdown', MdsDropdown);
